import { Box, Flex } from '@chakra-ui/react';
import {
  Icon,
  ListItemComp,
  ListItemCompContent,
  ListItemCompLeading,
  MeshMavenGlassesOnDefault as MeshMavenGlassesOnDefaultIcon,
} from '@mesh.ai/rabbit';

import BetaTag from 'uiToolkitV1/Tag/BetaTag';
import { TextHeader3 } from 'uiToolkitV1/Typography';

import { REVIEW_ACTIONS, REVIEW_ACTION_ITEM_TAG_MAP } from '../constant';
import { type ReviewActionPlanItem } from '../types';
import { ActionListItem } from './ActionListItem';

type MavenSuggestionCardProps = {
  onActionSelect: (actionType: keyof typeof REVIEW_ACTIONS, actionItemId: number) => void;
  reviewActionPlanItems: ReviewActionPlanItem[];
  reviewCycle: string;
  refetchActionPlanList: () => void;
};

export const MavenSuggestionCard = ({
  onActionSelect,
  reviewActionPlanItems = [],
  reviewCycle,
  refetchActionPlanList,
}: MavenSuggestionCardProps) => (
  <Box
    w="100%"
    sx={{
      borderRadius: '8px',
      padding: '1px',
      background:
        'linear-gradient(90deg, rgba(0, 142, 240, 0.50) 1.83%, rgba(236, 59, 100, 0.50) 34.86%, rgba(255, 194, 0, 0.50) 65.54%, rgba(92, 196, 97, 0.50) 100%)',
    }}
  >
    <Box background="white" borderRadius="8px">
      <Flex
        sx={{
          background:
            'linear-gradient(106.11deg, rgba(0, 142, 240, 0.03) 1.41%, rgba(236, 59, 100, 0.03) 36.8%, rgba(255, 194, 0, 0.03) 69.67%, rgba(92, 196, 97, 0.03) 106.6%)',
        }}
        display="flex"
        alignItems="center"
        borderBottom="1px solid #CFD7DF"
      >
        <ListItemComp>
          <ListItemCompLeading>
            <Icon IconSVG={MeshMavenGlassesOnDefaultIcon} />
          </ListItemCompLeading>
          <ListItemCompContent style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
            <TextHeader3 bold>Suggested plan by Maven</TextHeader3>
            <BetaTag />
          </ListItemCompContent>
        </ListItemComp>
      </Flex>
      {reviewActionPlanItems.map(({ id, actionItemText, isCompleted, tag, fromEmployee, isMlGenerated, isEdited }) => (
        <ActionListItem
          key={id}
          id={id}
          title={actionItemText}
          isChecked={isCompleted}
          tag={REVIEW_ACTION_ITEM_TAG_MAP[tag]}
          module={REVIEW_ACTION_ITEM_TAG_MAP[tag]}
          onActionSelect={onActionSelect}
          fromEmployee={fromEmployee || {}}
          reviewCycle={reviewCycle}
          refetchActionPlanList={refetchActionPlanList}
          isMlGenerated={isMlGenerated}
          isEdited={isEdited}
        />
      ))}
    </Box>
  </Box>
);
